"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKTOUTMAPPINGS = exports.InputFieldMappingTable = void 0;
exports.InputFieldMappingTable = {
    membershipNameInput: {
        id: 'input[name="Memberships"]:checked',
        localStorageKey: 'membershipName',
    },
    termSwitcher: {
        id: 'term-switcher',
        localStorageKey: 'term',
    },
};
exports.CHECKTOUTMAPPINGS = __assign({}, exports.InputFieldMappingTable);
// termswitcher
// step no 1: set #term-switcher id for parent of the tabs
// step no 2: set [data-set="termvalue"] for the tabs
// step no 3: set [data-wrapper="termvalue"] for the containers
